import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';
import { CustomerTheme } from 'src/app/interfaces/customer-theme';

@Injectable({
  providedIn: 'root'
})
export class CustomerThemeProviderService {
    protected webProvider = inject(WebProviderService);
    protected readonly baseURL = environment.apiURL;

    async getWithRingBuilderID(ringBuilderID: string): Promise<CustomerTheme | null> {
        return this.get(`customer/${ringBuilderID}`);
    }

    async getWithIframeID(iframeID: string): Promise<CustomerTheme | null> {
        return this.get(`iframe/${iframeID}`);
    }

    async get(path: string): Promise<CustomerTheme | null> {
        try {
            return await this.webProvider.get<CustomerTheme>(`${this.baseURL}/api/CustomerThemes/${path}`);
        } catch (error) {
            if (error instanceof HttpErrorResponse && error.status === 404) {
                return null;
            }
            throw new Error('Failed to fetch theme for customer');
        }
    }
}
